var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29 7H3a1 1 0 00-1 1v16a1 1 0 001 1h26a1 1 0 001-1V8a1 1 0 00-1-1zM12.395 18.814c.896 0 1.4-.415 1.4-1.165 0-.706-.493-1.109-1.356-1.109h-.963v-1.344h.986c.728 0 1.097-.313 1.097-.918 0-.571-.481-.93-1.243-.93a3.034 3.034 0 00-1.59.46l-.19-.112V12.43a4.19 4.19 0 012.005-.436c1.568 0 2.61.84 2.61 2.127a1.812 1.812 0 01-1.008 1.658v.123a1.938 1.938 0 011.198 1.837c0 1.512-1.041 2.419-2.8 2.43a4.094 4.094 0 01-2.195-.549v-1.277l.19-.112a3.102 3.102 0 001.859.583zm6.627 1.355c-1.825 0-2.632-1.243-2.632-4.088s.807-4.088 2.632-4.088 2.633 1.243 2.633 4.088-.807 4.088-2.633 4.088z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.022 13.337c-.806 0-1.086.694-1.086 2.744s.28 2.744 1.086 2.744 1.087-.695 1.087-2.744-.28-2.744-1.087-2.744z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--ticket-30-days-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'Ticket30DaysIcon';
export default Icon;